<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Add Gift Card
    </Teleport>

    <div
      v-if="balanceCheckCard"
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-8 animation-slide-left"
    >
      <button
        type="button"
        tabindex="-1"
        class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8"
        @click="resetBalanceCheckCard"
      >
        <span class="cf-icon cf-icon--smedium far fa-arrow-left" />

        <h2 class="cf-title cf-title--2">
          Add a different card
        </h2>
      </button>

      <p
        v-if="balanceCheckCard.amount > 0"
        class="cf-subtitle cf-subtitle--2"
      >
        The current balance on this gift card is:
      </p>

      <p
        v-else
        class="cf-subtitle cf-subtitle--2"
      >
        Your card shows no remaining balance. You can choose to add additional funds.
      </p>

      <h2 class="cf-title cf-title--2">
        {{ $dollars(balanceCheckCard.amount) }}
      </h2>

      <template v-if="balanceCheckCard.amount === 0">
        <button
          v-if="giftCards.savedCards.length > 1"
          type="button"
          class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
          @click="$closeModal('giftCardAdd')"
        >
          No Thanks
        </button>

        <button
          v-else
          type="button"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
          :class="{
            'cf-button--loading': isSavingCard
          }"
          @click="saveCard(balanceCheckCard, true)"
        >
          Add Funds
        </button>
      </template>

      <button
        v-else
        type="button"
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        :class="{
          'cf-button--loading': isSavingCard
        }"
        @click="saveCard(balanceCheckCard)"
      >
        Add Card To Account
      </button>
    </div>

    <template v-else>
      <p class="cf-subtitle cf-subtitle--2">
        Enter your gift card information below to check a balance or redeem.
      </p>

      <gift-card-balance-check
        :prefill="prefill"
        @success="balanceCheckSuccess"
      />
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import GiftCardBalanceCheck from './cf-gift-card-balance-check/index.vue';


  export default {
    name: 'GiftCardAdd',

    components: {
      GiftCardBalanceCheck
    },

    props: {
      prefill: {
        type: Object,
        default() {
          return {};
        }
      }
    },

    data() {
      return {
        balanceCheckCard: null,
        isSavingCard: false
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards'])
    },

    methods: {
      balanceCheckSuccess(data) {
        this.balanceCheckCard = data;
      },

      resetBalanceCheckCard() {
        this.balanceCheckCard = null;
      },

      async saveCard(card, isAddingFunds) {
        try {
          this.isSavingCard = true;

          const savedCard = await this.$store.dispatch('giftCards/saveCard', {
            cardNumber: card.cardNumber,
            pin: card.pin
          });

          // this.$triggerGoogleTrackingEvent('AddNewGiftCard', 'GiftCards');

          this.$triggerNewRelicEvent('AddNewGiftCard', 'Information', 'Added New Gift Card');

          this.$closeModal('giftCardAdd');

          if (isAddingFunds) {
            this.$openModal('giftCardPurchase', {
              cardToReload: savedCard
            });
          }
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isSavingCard = false;
        }
      }
    }
  };
</script>
